<ng-container *ngIf="currentImage$ | async as current">
    <div class="gallery-toolbar">

        <h4 class="gallery-toolbar-label">{{ groupLabel }}</h4>

        <div class="spacer"></div>

        <button type="button" mat-flat-button color="primary"
                [disabled]="!hasDirtyDates() || (saveStatus$ | async) === SaveDatesStatus.LOADING"
                (click)="save()">
            Save
        </button>

        <button type="button" mat-icon-button [matTooltip]="hasDirtyDates() ? 'Cancel' : 'Close'"
                [disabled]="(saveStatus$ | async) === SaveDatesStatus.LOADING"
                (click)="close()">
            <mat-icon>close</mat-icon>
        </button>

    </div>
    <div class="gallery-date-bar" *ngIf="currentDateGroup$ | async as dateGroup" [formGroup]="dateGroup">
        <mat-form-field appearance="standard" class="date-field">
            <mat-label>Observed Date</mat-label>
            <input type="text" matInput formControlName="takenAt"
                   [matDatepicker]="takenDatepicker">
            <mat-datepicker-toggle matSuffix [for]="takenDatepicker">
            </mat-datepicker-toggle>
            <mat-datepicker #takenDatepicker></mat-datepicker>
            <mat-error>Select a date</mat-error>
            <mat-hint>{{ dateGroup.get('takenAt').value | amTimeAgo }}</mat-hint>
        </mat-form-field>
    </div>
    <div class="gallery-viewport">

        <pv-image-ref class="image-preview"
                        [fileRef]="current.fileRef"
                        transformId="preview_2000"
                        format="jpeg"
                        [alt]="groupLabel">
        </pv-image-ref>

    </div>
</ng-container>
<div class="gallery-footer">
    <button mat-icon-button type="button" class="gallery-control left"
            [attr.aria-label]="'Previous ' + groupLabel + ' image'"
            (click)="prevImage()">
        <mat-icon>navigate_before</mat-icon>
    </button>

    <cdk-virtual-scroll-viewport #scrollViewport
                                    class="gallery-items"
                                    itemSize="56"
                                    minBufferPx="200"
                                    orientation="horizontal"
                                    maxBufferPx="400">
        <pv-image-ref *cdkVirtualFor="let image of images; index as i; trackBy: trackImage"
                        class="image-item"
                        [class.current]="currentIndex$.getValue() === i"
                        (click)="selectImage(i)"
                        [fileRef]="image.fileRef"
                        transformId="thumb_72"
                        [attr.aria-label]="groupLabel + ' image ' + (i + 1) + ' of ' + images.length">
        </pv-image-ref>
    </cdk-virtual-scroll-viewport>

    <button mat-icon-button type="button" class="gallery-control right"
            [attr.aria-label]="'Next ' + groupLabel + ' image'"
            (click)="nextImage()">
        <mat-icon>navigate_next</mat-icon>
    </button>
</div>
